import type { Dtos } from "@inrev/common";
import { Modal } from "@portal/components/layout/Modal";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { FC } from "react";
import { CompanyCreditReportDetail } from "./CompanyCreditReportDetail";
import { companyCreditFailureMessage } from "./utils/companyCreditFailureMessage";

type Company = Dtos.Admin.SuretyAccount.Get.Response["companies"][number];
type CompanyCreditReport = Company["creditReports"][number];

type CompanyCreditReportModalProps = {
	company: Company;
	report: CompanyCreditReport | undefined;
	onClose: () => void;
};

export const CompanyCreditReportModal: FC<CompanyCreditReportModalProps> = ({
	company,
	report,
	onClose,
}) => {
	return (
		<Modal onClickOutside={onClose} itemClassName="w-full">
			<div className="contents" onWheel={(e) => e.stopPropagation()}>
				<ModalItemWithHeader
					className="amp-mask max-w-[min(900px,92vw)] w-full max-h-[min(85vh,900px)] flex flex-col"
					bodyClassName="overflow-y-auto overscroll-contain min-h-0"
					header={company.name}
					onClose={onClose}
				>
					<div
						className="px-[24px] pb-[28px] pt-[8px]"
						data-testid="company_credit_report_modal_content"
					>
						{report?.success ? (
							<CompanyCreditReportDetail report={report} company={company} />
						) : (
							<p className="text-secondary text-[14px]">
								{companyCreditFailureMessage(report) ??
									"No successful credit report on file for this company."}
							</p>
						)}
					</div>
				</ModalItemWithHeader>
			</div>
		</Modal>
	);
};
